import { cva } from '@/styled-system/css';

export const gleamDotRecipe = cva({
  base: {
    backgroundColor: 'bg.feedback.notify.hero-fixed',
    borderRadius: 'shape.capsule',
    color: 'text.onHero.neutral-fixed',
    display: 'inline-flex',
    flexShrink: 0,
    height: '300',
    width: '300',
  },
  compoundVariants: [
    {
      tone: 'info',
      onImpact: false,
      css: {
        backgroundColor: 'bg.feedback.info.impact',
        color: 'text.onImpact.neutral',
      },
    },
    {
      tone: 'info',
      onImpact: true,
      css: {
        backgroundColor: 'bg.feedback.info.soft',
        color: 'text.feedback.info.strong',
      },
    },
    {
      tone: 'new',
      onImpact: false,
      css: {
        backgroundColor: 'Gleam.new.bg',
        color: 'Gleam.new.text',
      },
    },
    {
      tone: 'new',
      onImpact: true,
      css: {
        backgroundColor: 'bg.feedback.success.soft',
        color: 'Gleam.onImpact.new.text',
      },
    },
  ],
});
